import { ComponentProps, FC, ReactNode } from 'react'

import { cva } from 'class-variance-authority'

import { IconCheckboxChecked } from '~/components/ui/icons/checkbox-checked'
import { IconCheckboxEmpty } from '~/components/ui/icons/checkbox-empty'
import { twMerge } from '~/lib/utils'

type CheckboxProps = {
  label: ReactNode
  textSize?: 'sm' | 'base'
  className?: string
} & Omit<ComponentProps<'input'>, 'type' | 'className'>

const textVariants = cva(null, {
  variants: {
    textSize: {
      sm: 'text-body-s',
      base: 'text-body',
    },
  },
})

export const Checkbox: FC<CheckboxProps> = ({
  label,
  textSize = 'base',
  className,
  ...inputProps
}) => {
  const { checked, disabled, onClick } = inputProps
  return (
    <label
      className={twMerge(
        'flex items-center py-2',
        !disabled && 'hover:cursor-pointer',
        className,
      )}
    >
      <input
        className="hidden"
        onClick={onClick}
        type="checkbox"
        {...inputProps}
      />
      <span className="mr-2">
        {checked ? <IconCheckboxChecked /> : <IconCheckboxEmpty />}
      </span>
      <span
        className={twMerge(
          textVariants({ textSize }),
          checked && 'font-bold',
          disabled && 'text-grayText',
        )}
      >
        {label}
      </span>
    </label>
  )
}
